<script setup>
import { ref } from 'vue'
import {__, mareike_check_filesize} from '../../../assets/javascripts/library.js'
import InfoIcon from '../../../assets/components/InfoIcon.vue'
import RefundData from "./refund-data.vue";
import NumericInput from "../../../assets/components/NumericInput.vue";
import AmountInput from "../../../assets/components/AmountInput.vue";

const data = defineProps({
  user_id: Number,
  eventId: Number,
  dynamicText: Object,
  user_name: String,
  user_email: String,
  user_iban: String,
  user_account_owner: String,
  distance_allowance: Number,
})


const travelDirection = ref(null);
const have_receipt = ref('')
const people_in_car = ref(1);
const material_trasnporation = ref(false);
const amount = ref(0);
const invoiceType = ref(null);

const otherText = ref('');
const receipt = ref(null)
const finalStep = ref(false)

function handleFileChange(event) {
  if (mareike_check_filesize('receipt')) {
    receipt.value = event.target.files[0]
    finalStep.value = true
  } else {
    event.target.value = null
  }
}

</script>

<template>
  <fieldset>
    <legend><span style="font-weight: bolder;">{{__( 'Please indicate your route', 'mareike' )}}</span></legend>
    <input
        type="text"
        class="mareike-text  w-full"
        name="travel-direction"
        v-model="travelDirection"
    />
  </fieldset><br /><br />

  <fieldset v-if="travelDirection !== null">
    <legend><span style="font-weight: bolder;">{{__( 'Have you traveled by public transport or a rental car and have a receipt?', 'mareike' )}}</span></legend>
    <button class="mareike-button" style="border-radius: 0; width: 100px;" @click="have_receipt='yes'">{{__( 'Yes', 'mareike')}}</button>
    <button class="mareike-button" style="border-radius: 0; width: 100px;" @click="have_receipt='no'">{{__( 'No', 'mareike') }}</button>
  </fieldset>

  <br /><br />

  <fieldset v-if="have_receipt === 'yes'">
    <legend><span style="font-weight: bolder;">{{ __( 'How much is the amount?', 'mareike' ) }}</span></legend>
    <AmountInput v-model="amount" class="mareike-text" id="amount" name="amount"  /> Euro
    <info-icon></info-icon>

    <br /><br />
    <button
      v-if="amount !== null && have_receipt === 'yes'"
      class="mareike-button"
      onclick="document.getElementById('receipt').click();"
      type="button"
    >
    {{__( 'Select receipt and continue', 'mareike' )}}
    </button>
    <input accept="application/pdf" type="file" id="receipt" name="receipt"     @change="handleFileChange"
         style="display: none"/>

    <RefundData
      v-if="finalStep && have_receipt === 'yes'"
      :event-id="data.eventId"
      invoice-type="Travelling"
      :amount="amount"
      :other-text="travelDirection"
      :receipt="receipt"
      :user_name="data.user_name"
      :user_email="data.user_email"
      :user_iban="data.user_iban"
      :dynamicText="data.dynamicText"
      :user_account_owner="data.user_account_owner"
    />
  </fieldset>

  <fieldset v-else-if="have_receipt === 'no'">
    <legend><span style="font-weight: bolder;">{{ __( 'Information about the trip', 'mareike' ) }}</span></legend>
    {{ __('Total number of people in the car', 'mareike')}}:

    <NumericInput v-model="people_in_car" class="mareike-text" :min="1" :max="9" />
<br />

    <input
        type="checkbox"
        name="material_trasnporation"
        v-model="material_trasnporation"
        id="material_trasnporation"
    /> <label for="material_trasnporation">{{__( 'I carried material', 'mareike' )}}</label><br />

    {{ __('Total distance', 'mareike')}}:
    <NumericInput
        class="mareike-text"
        name="total_distance"
        v-model="amount"
     /> km<br />
    <span style="font-weight: normal">({{ amount }} km x {{data.distance_allowance}} Euro / km = {{amount * data.distance_allowance}} Euro)</span>
    <br />

    <button
        v-if="amount !== null && have_receipt === 'no'"
        class="mareike-button"
        @click="finalStep = true;"
        type="button"
    >
      {{__( 'Bill a flat invoice', 'mareike' )}}
    </button>

    <RefundData
        v-if="finalStep && have_receipt === 'no'"
        :event-id="data.eventId"
        invoice-type="Travelling"
        :amount="amount"
        :other-text="travelDirection"
        :material_transportation="material_trasnporation"
        :people_in_car="people_in_car"
        :user_name="data.user_name"
        :user_email="data.user_email"
        :user_iban="data.user_iban"
        :dynamicText="data.dynamicText"
        :user_account_owner="data.user_account_owner"
        :user_id="data.user_id"
    />

  </fieldset>

</template>

<style scoped>

</style>




